import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'vue-material-design-icons/styles.css';
import Vuelidate from 'vuelidate'
import Toasted from 'vue-toasted';
import Paginate from 'vuejs-paginate'
import vueNumeralFilterInstaller from 'vue-numeral-filter';

Vue.use(vueNumeralFilterInstaller);
Vue.prototype.$upd = new Vue();
Vue.component('paginate', Paginate)
Vue.use(Toasted)
Vue.use(Vuelidate)
Vue.config.productionTip = false
Vue.prototype.$apiURI = "https://ecodom04.com/backend/api/";

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
